import { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import { BetterVue } from './tools';

@ComponentDecorator({
  props: {
    text: String,
    cclass: String,
    to: String,
    forceAH: Boolean,
  },
})

export default class CubeButton extends BetterVue {
  private reClick: boolean = false;
  ButtonClick(e: any) {
    let self = this as any;
    if (`${self.to}`.indexOf('http') === 0) {
      location.href = self.to;
      return e.stopPropagation();
    }
    if (`${self.to}`.indexOf('#') === 0) {
      /*setTimeout(() => {
        location.hash = `${self.to}`;
      }, 1000);*/
      let elem = document.getElementById(`${self.to}`.substr(1));
      if (elem === undefined || elem === null) {
        throw `${self.to} elem not found`;
      }
      elem.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return e.stopPropagation();
    }
    return false;
  }
}
